import { render, staticRenderFns } from "./infoboxSB.vue?vue&type=template&id=1a3c0137&scoped=true&"
import script from "./infoboxSB.vue?vue&type=script&lang=js&"
export * from "./infoboxSB.vue?vue&type=script&lang=js&"
import style0 from "./infoboxSB.vue?vue&type=style&index=0&id=1a3c0137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c0137",
  null
  
)

export default component.exports